/* eslint-disable radix */
const mapStationData = (station) => {
  const data = {
    showStation: false,
    left: 0,
    top: 0,
    centerLeft: 0,
    centerTop: 0,
  };

  if (station === 'AES') {
    data.left = 250;
    data.top = 565;
    data.centerLeft = 545;
    data.centerTop = 685;
  } else if (station === 'ALF') {
    data.left = 368;
    data.top = 85;
    data.centerLeft = 1080;
    data.centerTop = 100;
  } else if (station === 'ANX') {
    data.left = 1007;
    data.top = 192;
    data.centerLeft = 850;
    data.centerTop = 154;
  } else if (station === 'BGO') {
    data.left = 215;
    data.top = 715;
    data.centerLeft = 500;
    data.centerTop = 840;
  } else if (station === 'BJF') {
    data.left = 1306;
    data.top = 66;
    data.centerLeft = 1300;
    data.centerTop = 33;
  } else if (station === 'BNN') {
    data.left = 283;
    data.top = 385;
    data.centerLeft = 725;
    data.centerTop = 490;
  } else if (station === 'BOO') {
    data.left = 1307;
    data.top = 334;
    data.centerLeft = 811;
    data.centerTop = 315;
  } else if (station === 'BVG') {
    data.left = 1391;
    data.top = 58;
    data.centerLeft = 1260;
    data.centerTop = 10;
  } else if (station === 'EVE') {
    data.left = 937;
    data.top = 248;
    data.centerLeft = 870;
    data.centerTop = 220;
  } else if (station === 'FDE') {
    data.left = 166;
    data.top = 642;
    data.centerLeft = 520;
    data.centerTop = 782;
  } else if (station === 'FRO') {
    data.left = 360;
    data.top = 624;
    data.centerLeft = 500;
    data.centerTop = 765;
  } else if (station === 'HAA') {
    data.left = 625;
    data.top = 47;
    data.centerLeft = 1050;
    data.centerTop = 46;
  } else if (station === 'HAU') {
    data.left = 598;
    data.top = 823;
    data.centerLeft = 510;
    data.centerTop = 894;
  } else if (station === 'HFT') {
    data.left = 731;
    data.top = 38;
    data.centerLeft = 1100;
    data.centerTop = 30;
  } else if (station === 'HOV') {
    data.left = 1129;
    data.top = 630;
    data.centerLeft = 520;
    data.centerTop = 711;
  } else if (station === 'HVG') {
    data.left = 1113;
    data.top = 120;
    data.centerLeft = 1160;
    data.centerTop = 0;
  } else if (station === 'KKN') {
    data.left = 1269;
    data.top = 220;
    data.centerLeft = 1300;
    data.centerTop = 110;
  } else if (station === 'KRS') {
    data.left = 319;
    data.top = 854;
    data.centerLeft = 600;
    data.centerTop = 973;
  } else if (station === 'KSU') {
    data.left = 368;
    data.top = 525;
    data.centerLeft = 570;
    data.centerTop = 648;
  } else if (station === 'LKL') {
    data.left = 1121;
    data.top = 211;
    data.centerLeft = 1133;
    data.centerTop = 86;
  } else if (station === 'LKN') {
    data.left = 250;
    data.top = 230;
    data.centerLeft = 760;
    data.centerTop = 275;
  } else if (station === 'LYR') {
    data.left = 188;
    data.top = 33;
    data.centerLeft = 570;
    data.centerTop = 235;
  } else if (station === 'MEH') {
    data.left = 848;
    data.top = 20;
    data.centerLeft = 1230;
    data.centerTop = 0;
  } else if (station === 'MJF') {
    data.left = 1065;
    data.top = 420;
    data.centerLeft = 760;
    data.centerTop = 440;
  } else if (station === 'MOL') {
    data.left = 1233;
    data.top = 602;
    data.centerLeft = 570;
    data.centerTop = 675;
  } else if (station === 'MQN') {
    data.left = 1161;
    data.top = 392;
    data.centerLeft = 787;
    data.centerTop = 410;
  } else if (station === 'OSL') {
    data.left = 1012;
    data.top = 773;
    data.centerLeft = 675;
    data.centerTop = 866;
  } else if (station === 'OSY') {
    data.left = 843;
    data.top = 507;
    data.centerLeft = 711;
    data.centerTop = 550;
  } else if (station === 'RET') {
    data.left = 145;
    data.top = 260;
    data.centerLeft = 725;
    data.centerTop = 310;
  } else if (station === 'RVK') {
    data.left = 1160;
    data.top = 473;
    data.centerLeft = 690;
    data.centerTop = 520;
  } else if (station === 'SDN') {
    data.left = 1010;
    data.top = 648;
    data.centerLeft = 500;
    data.centerTop = 740;
  } else if (station === 'SKN') {
    data.left = 482;
    data.top = 184;
    data.centerLeft = 820;
    data.centerTop = 215;
  } else if (station === 'SOG') {
    data.left = 1121;
    data.top = 713;
    data.centerLeft = 565;
    data.centerTop = 790;
  } else if (station === 'SOJ') {
    data.left = 263;
    data.top = 99;
    data.centerLeft = 1010;
    data.centerTop = 115;
  } else if (station === 'SSJ') {
    data.left = 584;
    data.top = 364;
    data.centerLeft = 750;
    data.centerTop = 404;
  } else if (station === 'SVG') {
    data.left = 171;
    data.top = 800;
    data.centerLeft = 515;
    data.centerTop = 935;
  } else if (station === 'SVJ') {
    data.left = 374;
    data.top = 215;
    data.centerLeft = 800;
    data.centerTop = 245;
  } else if (station === 'TOS') {
    data.left = 160;
    data.top = 114;
    data.centerLeft = 940;
    data.centerTop = 130;
  } else if (station === 'TRD') {
    data.left = 543;
    data.top = 477;
    data.centerLeft = 670;
    data.centerTop = 630;
  } else if (station === 'TRF') {
    data.left = 1081;
    data.top = 848;
    data.centerLeft = 655;
    data.centerTop = 915;
  } else if (station === 'VAW') {
    data.left = 1396;
    data.top = 148;
    data.centerLeft = 1328;
    data.centerTop = 62;
  } else if (station === 'VDS') {
    data.left = 1378;
    data.top = 198;
    data.centerLeft = 1295;
    data.centerTop = 80;
  }

  return data;
};

export default mapStationData;
